import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import './StoreCheckbox.scss';

type Props = {
    rtl: boolean;
    handleCheckedChange: any;
    checked: boolean;
}

function StoreCheckbox({ rtl, checked, handleCheckedChange }: Props) {
    const { t } = useTranslation();

    return (
        <Typography rtl={rtl} className='store_Checkbox'>
            <label>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={handleCheckedChange}
                    style={!rtl ? { marginRight: '18px' } : { marginLeft: '18px' }}
                />
                <span className="open">{t('Open_now')}</span>
            </label>
        </Typography>
    )
}

export default StoreCheckbox